/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CopyInputs */

const en_common_copy = /** @type {(inputs: Common_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const de_common_copy = /** @type {(inputs: Common_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren`)
};

const fr_common_copy = /** @type {(inputs: Common_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier`)
};

const es_common_copy = /** @type {(inputs: Common_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const it_common_copy = /** @type {(inputs: Common_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia`)
};

const nl_common_copy = /** @type {(inputs: Common_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiëren`)
};

const pl_common_copy = /** @type {(inputs: Common_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiuj`)
};

const fi_common_copy = /** @type {(inputs: Common_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopioi`)
};

const da_common_copy = /** @type {(inputs: Common_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopier`)
};

const sv_common_copy = /** @type {(inputs: Common_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiera`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Common_CopyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_copy = /** @type {((inputs?: Common_CopyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CopyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_copy(inputs)
	if (locale === "fr") return fr_common_copy(inputs)
	if (locale === "es") return es_common_copy(inputs)
	if (locale === "it") return it_common_copy(inputs)
	if (locale === "nl") return nl_common_copy(inputs)
	if (locale === "pl") return pl_common_copy(inputs)
	if (locale === "fi") return fi_common_copy(inputs)
	if (locale === "da") return da_common_copy(inputs)
	if (locale === "sv") return sv_common_copy(inputs)
	return en_common_copy(inputs)
});